import { create } from "zustand";
import type { IProposalSocials } from "../hooks/http/admin/proposal-creators/add-proposal-social.admin.http";

interface IProposalSocialSearchStore {
  data: IProposalSocials[];
  setData: (data: IProposalSocials[]) => void;
  removeById: (id: string) => void;
  markCommentsRead: (id: string, user: string) => void;
  updateCommentCount: (id: string, count: number) => void;
}

const useProposalSocialSearchStore = create<IProposalSocialSearchStore>(
  (set) => ({
    data: [],
    setData: (data: IProposalSocials[]) => set(() => ({ data })),
    removeById: (id: string) =>
      set((state) => ({
        data: state.data.filter((user) => user.social.id !== id),
      })),
    markCommentsRead: (id: string, user: string) =>
      set((state) => ({
        data: state.data.map((item) => {
          if (item.proposalSocial?.id === id) {
            item.proposalSocial.commentReadByUsersList.push(user);
          }
          return item;
        }),
      })),
    updateCommentCount: (id: string, count: number) =>
      set((state) => ({
        data: state.data.map((item) => {
          if (item.proposalSocial?.id === id) {
            item.proposalSocial.commentCount = count;
          }
          return item;
        }),
      })),
  })
);

export default useProposalSocialSearchStore;
